import { Routes } from '@angular/router';

export const buyedRoutes: Routes = [
    {
        path: 'checkout',
        loadComponent: () =>
            import('./containers/checkout/checkout.component').then((m) => m.CheckoutComponent),
    },
    {
        path: 'failed',
        loadComponent: () =>
            import('./components/fail-payment/fail-payment.component').then((m) => m.FailPaymentComponent),
    },
    {
        path: 'pending',
        loadComponent: () =>
            import('./components/pending/pending.component').then((m) => m.PendingComponent),
    },
    {
        path: 'success',
        loadComponent: () =>
            import('./components/success/success.component').then((m) => m.SuccessComponent),
    },
    {
        path: 'cancel',
        loadComponent: () =>
            import('./components/cancel/cancel.component').then((m) => m.CancelComponent),
    },
    {
        path: '**',
        redirectTo: 'checkout',
    },
];
